import { createFileRoute } from '@tanstack/react-router';
import EnableMfaPage from 'src/features/plugins/outlook/(auth)/(setup)/enable-mfa/page';

export const Route = createFileRoute('/plugins/outlook/_outlookAuth/_outlookSetup/enable-mfa')({
  component: EnableMfaPage,
});
